<template>
    <input-group
        :prepend="true"
        :append="true"
        icon="fas fa-filter"
    >
        <input ref="input" class="form-control" type="text" v-model="newValue" @keydown.esc="newValue = ''">
        <template v-slot:append v-if="value !== ''">
            <span class="input-group-text clear" @click="newValue = ''">
                    <i class="fas fa-times"></i>
            </span>
        </template>
    </input-group>
</template>

<script>

import InputGroup from '@core/Components/Inputs/InputGroup.vue';

export default {
    name: 'datatable-filter',
    components: {
        InputGroup
    },
    mounted() {
        if(this.focusOnLoad) {
            $(this.$refs.input).focus();
        }
    },
    computed: {
        newValue:{
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        focusOnLoad: Boolean
    }
}
</script>

<style lang="scss" scoped>
    .input-group-text.clear {
        cursor: pointer;

        &:hover {
            color: white !important;
            background-color:crimson;
            border-color: black;
            border-left: 2px solid black;
        }
    }
    
</style>